import ReactDOM from "react-dom";

import RestoreContentWrapper from "@/components/elements/RestoreContentFromPage/RestoreContentFromPage";

const RestoreContentFromPagePortal = () =>  {

       
        let targetContainer = document.getElementById('react-restore-button');
        if (!targetContainer) {
                //if there is nowhere for the portal, do not display
                return null;

        } else {
                const contentId: string = targetContainer.getAttribute('data-contentid') || "";
                const appId: string = targetContainer.getAttribute('data-appid') || "";
              

                return ReactDOM.createPortal(
                        <RestoreContentWrapper contentId={contentId} appId={appId}/>,
                        targetContainer
                );
        }
} 

export default RestoreContentFromPagePortal;
